import React,{useContext,useCallback} from "react";
import AnalyticsHome from "components/analytics/AnalyticsHome";

function AnalyticsPage() {
    return <AnalyticsHome />
}

export default AnalyticsPage;
